import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router"
import LandingGate from "@/modules/landing/LandingGate.vue"
import LoginPage from "@/modules/auth/LoginPage.vue"
import SignupPage from "@/modules/auth/SignupPage.vue"
import SetupPage from "@/modules/auth/SetupPage.vue"
import HomePage from "@/modules/home/HomePage.vue"
import ProjectPage from "@/modules/project/ProjectPage.vue"
import TestcasePage from "@/modules/testcase/TestcasePage.vue"
import ExecutionPage from "@/modules/execution/ExecutionPage.vue"
import RunPage from "@/modules/run/RunPage.vue"
import SchedulePage from "@/modules/schedule/SchedulePage.vue"
import ViewerPage from "@/modules/viewer/ViewerPage.vue"

const routes: RouteRecordRaw[] = [
    {
        path: "/",
        component: AUTH_PROVIDER === "testup-auth" ? LandingGate : HomePage,
        meta: {
            auth: AUTH_PROVIDER !== "testup-auth",
            breadcrumb: [
                {
                    text: "Testup",
                },
            ],
        },
    },
    {
        path: "/login",
        component: LoginPage,
        meta: {
            auth: false,
            layout: "empty",
            hideSidePane: true,
        },
    },
    {
        path: "/signup",
        component: SignupPage,
        meta: {
            auth: false,
            layout: "empty",
            hideSidePane: true,
        },
    },
    {
        path: "/setup",
        component: SetupPage,
        meta: {
            auth: false,
            layout: "empty",
            hideSidePane: true,
        },
    },
    {
        path: "/project/:projectId/:recordingId?",
        alias: ["/project/:projectId/view/:recordingId?"],
        component: ProjectPage,
        meta: {
            auth: true,
            breadcrumb: [
                {
                    path: "/",
                    text: "Testup",
                },
                {
                    text: "{{projectName}}",
                },
            ],
        },
    },
    {
        path: "/testcase/:testcaseId/:recordingId?",
        alias: ["/testcase/:testcaseId/view/:recordingId?"],
        component: TestcasePage,
        meta: {
            auth: true,
            breadcrumb: [
                {
                    path: "/",
                    text: "Testup",
                },
                {
                    path: "/project/{{projectId}}",
                    text: "{{projectName}}",
                },
                {
                    text: "{{testcaseName}}",
                },
            ],
        },
    },
    {
        path: "/execution/:executionId/:recordingId?",
        alias: ["/execution/:executionId/view/:recordingId?"],
        component: ExecutionPage,
        meta: {
            auth: true,
            breadcrumb: [
                {
                    path: "/",
                    text: "Testup",
                },
                {
                    path: "/project/{{projectId}}",
                    text: "{{projectName}}",
                },
                {
                    text: "{{executionName}}",
                },
            ],
        },
    },
    {
        path: "/run/:testId",
        name: "run",
        component: RunPage,
        meta: {
            layout: "empty",
            auth: true,
            breadcrumb: [
                {
                    path: "/",
                    text: "Testup",
                },
                {
                    path: "/project/{{projectId}}",
                    text: "{{projectName}}",
                },
                {
                    path: "/testcase/{{testcaseId}}",
                    text: "{{testcaseName}}",
                },
                {
                    text: "Editor",
                },
            ],
        },
    },
    {
        path: "/schedule/:scheduleId/:recordingId?",
        alias: ["/schedule/:scheduleId/view/:recordingId?"],
        component: SchedulePage,
        meta: {
            auth: true,
            breadcrumb: [
                {
                    path: "/",
                    text: "Testup",
                },
                {
                    path: "/project/{{projectId}}",
                    text: "{{projectName}}",
                },
                {
                    text: "{{scheduleName}}",
                },
            ],
        },
    },
    {
        path: "/viewer/:recordingId",
        component: ViewerPage,
        meta: {
            auth: false,
            hideSidePane: true,
        },
    },
    {
        path: "/viewer/latest/:testcaseId",
        component: ViewerPage,
        meta: {
            auth: false,
            hideSidePane: true,
        },
    },
]

export const router = createRouter({
    history: createWebHistory(),
    routes,
})
